import { useTranslation } from 'react-i18next'

import { MENU_CALENDAR_ITEM } from '../../../constants/menu'
import { usePageBrowserTabTitle } from '../../../hooks'
import { Page } from '../../Page'
import { PageHeader } from '../../PageHeader'
import { CalendarSection } from '../CalendarSection'

import { QA_NAME_CALENDAR_PAGE } from './CalendarPage.constants'

function CalendarPage() {
  const { t } = useTranslation()

  usePageBrowserTabTitle({ pageTitle: t('BrowserTab.CalendarPageTitleKey') })

  return (
    <Page qaName={QA_NAME_CALENDAR_PAGE}>
      <PageHeader title={t(MENU_CALENDAR_ITEM.title)} />
      <CalendarSection />
    </Page>
  )
}

export default CalendarPage
